import React, { FC } from 'react'

import { IndexLayoutLoadingOld as BaseIndexLayoutLoading } from '../IndexLayoutOld'

export const IndexLayoutLoading: FC = () => <BaseIndexLayoutLoading />
